<template>
  <div>
    <v-container class="fill-height text-center containerheight" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="pt-10">
            <v-img fluid class="mb-5 mx-10" :src="require('@/assets/MEMEX-logo.svg')"></v-img>
            <v-icon class="alerticon">mdi-alert</v-icon>
            <h2>{{$t('pageNotFound')}}</h2>
            <v-card-text>
              <v-btn @click.prevent="goToLogin" type="submit" id="Login">{{$t('goBackAndTryAgain')}}</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'errorPage',
  components: {
  },
  data() {
    return {
    }

  },

  created() {
  },
  mounted(){
  },
  methods: {
        goToLogin: function () {
            this.$router.push("/home");
        }
  }
}
</script>
<style scoped>
.containerheight{
  height: 100vh;
}
.alerticon{
  color: red;
  font-size: 2rem;
}
</style>

